export default "__VITE_ASSET__CbLr8bfC__"